import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';
import { campsenum } from '../../../../models/enums.generated';

@Component({
    selector: 'app-purchase-info',
    templateUrl: './purchase-info.component.html',
    styleUrls: ['./purchase-info.component.scss'],
    standalone: false
})
export class PurchaseInfoComponent implements OnInit {

    @Input()
    public purchase: camps.CampPurchaseDetails;

    constructor(private enumTranslation: CampsEnumTranslationService) { }

    ngOnInit() {
    }


    public get isBuyerInOtherMembershipThanPayer():boolean{
        return this.purchase.finalizedByMembership != this.purchase.payerMembership;
    }

    public get campTypeLabel() {
        return this.enumTranslation.campType(this.purchase.campType);
    }

    public get isOfficePurchase(){
        return this.purchase.source == campsenum.CampPurchaseSource.Office;
    }
}
